const runtimeEnv = process.env.NODE_ENV
// const buildEnv = process.env.VUE_APP_BUILD

const serverURL = new Map([
  ['development', 'http://test-coconutapi.qixincha.com'],
  ['testbuild', 'http://test-coconutapi.qixincha.com'],
  ['production', 'https://coconutapi.qixincha.com'],
])

export const SERVER_API = serverURL.get(runtimeEnv)
export const test = '12312'
